var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('img',{attrs:{"id":"partnerize-pixel","src":_vm.srcUrl,"width":"1","height":"2","alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }